import { render, staticRenderFns } from "./BaseMarkdownViewer.vue?vue&type=template&id=cfd0d770&scoped=true"
import script from "./BaseMarkdownViewer.vue?vue&type=script&lang=js"
export * from "./BaseMarkdownViewer.vue?vue&type=script&lang=js"
import style0 from "./BaseMarkdownViewer.vue?vue&type=style&index=0&id=cfd0d770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd0d770",
  null
  
)

export default component.exports